import React from 'react';
import FileUpload from './FileUpload';
import './InputView.css';

const InputView = ({ 
  customerId,
  onCustomerIdChange,
  onFilesSelected,
  onTextInput,
  onCreateExtraction,
  isCreatingExtraction,
  isUploadingFiles,
  isProcessing,
  processingStep,
  selectedFiles,
  textInput,
  disabled
}) => {
  const canCreateExtraction = selectedFiles.length > 0 || textInput.trim();

  return (
    <div className="input-view">
      <div className="input-container">
        {/* <div className="customer-section">
          <label htmlFor="customer-id">ID do Cliente (opcional):</label>
          <input
            id="customer-id"
            type="text"
            value={customerId}
            onChange={(e) => onCustomerIdChange(e.target.value)}
            placeholder="Digite o ID do cliente..."
            className="customer-input"
            disabled={disabled}
          />
        </div> */}

        <FileUpload
          onFilesSelected={onFilesSelected}
          onTextInput={onTextInput}
          disabled={disabled}
        />

        <div className="action-buttons">
          <button 
            className="btn btn-primary extract-btn"
            onClick={onCreateExtraction}
            disabled={disabled || !canCreateExtraction}
          >
            {isCreatingExtraction ? (
              <>
                <div className="spinner"></div>
                Criando Extração...
              </>
            ) : isUploadingFiles ? (
              <>
                <div className="spinner"></div>
                Enviando Arquivos...
              </>
            ) : isProcessing ? (
              <>
                <div className="spinner"></div>
                {processingStep}
              </>
            ) : (
              'Criar Extração'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InputView;
